import { render, staticRenderFns } from "./SectionOutline.vue?vue&type=template&id=24b975d9&scoped=true&lang=pug&"
import script from "./SectionOutline.vue?vue&type=script&lang=js&"
export * from "./SectionOutline.vue?vue&type=script&lang=js&"
import style0 from "./SectionOutline.vue?vue&type=style&index=0&id=24b975d9&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24b975d9",
  null
  
)

export default component.exports